import cn from 'classnames';
import { Tooltip } from 'primereact/tooltip';
import { useTranslation } from 'react-i18next';

import { ThematicPackageSite } from '@features/campaigns/shared/types/thematicPackage.ts';
import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './ReferenceSitesTooltip.module.scss';

interface ReferenceSitesTooltipProps {
  targetId: string;
  sites: ThematicPackageSite[];
}

export function ReferenceSitesTooltip({ targetId, sites }: ReferenceSitesTooltipProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <>
      <i
        id={targetId}
        className={cn('pi pi-info-circle', styles.trigger)}
        data-pr-position='top'
        data-testid={targetId}
      ></i>

      <Tooltip target={`#${targetId}`} className={styles.panel}>
        <p className={styles.title}>{t('thematicPackage.packages.additionalSitesTitle')}</p>
        <ul className={styles.sites}>
          {sites.map(({ name, domain, logoUrl }) => (
            <li key={domain}>
              {logoUrl ? (
                <img className={styles.logo} src={logoUrl} alt={name} />
              ) : (
                <span className={styles.name}>{name}</span>
              )}
            </li>
          ))}
        </ul>
      </Tooltip>
    </>
  );
}
